module.exports = __webpack_public_path__ + "static/media/Gotham-Book.67f82136.woff";